import axios from "./axiosInstance";

const homepageAPI ={ 
    homepage_list: () => axios.post("homepage"),
}

export default homepageAPI;